import { Box, Button, TextField } from '@bechtel/gds';
import styled, { css } from 'styled-components';

interface EditCountFieldProps {
  itemCount: number;
  itemOnHandCount?: number | null;
  btnDisabled?: boolean;
  isPickedError: boolean;
}

export const EditCountFieldStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  px: { sm: '400' },
  py: { sm: '100' },
})<EditCountFieldProps>`
  border: 1px solid ${({ theme, isPickedError }) => (isPickedError ? theme.colors.red[700] : theme.colors.grey[400])};
  border-radius: calc(
    ${({ theme }) => theme.radii[800]} + ${({ theme }) => theme.radii[800]} + ${({ theme }) => theme.radii[200]}
  );
  max-width: 116px;
  background-color: ${({ theme, isPickedError }) => (isPickedError ? theme.colors.red[100] : theme.colors.white)};
  height: 36px;
  ${(props) =>
    props.itemCount > 0 &&
    !props.btnDisabled &&
    css`
      border: 1px solid ${({ theme }) => (props.isPickedError ? theme.colors.red[700] : theme.colors.blue[800])};
    `};
  ${(props) =>
    props.itemOnHandCount == 0 &&
    !props.btnDisabled &&
    css`
      color: 1px solid ${({ theme }) => theme.colors.grey[200]};
    `};
`;

export const EditCountTextFieldStyled = styled(TextField)<{ isPickedError: boolean }>`
  border: none;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
  max-width: 80px;
  height: 28px;
  background-color: ${({ theme, isPickedError }) => (isPickedError ? theme.colors.red[100] : theme.colors.white)};
  :focus {
    box-shadow: none;
  }
`;

export const EditCountButtonStyled = styled(Button)<{ isPickedError: boolean }>`
  padding-left: 0px;
  padding-right: 0px;
  height: 28px;
  min-width: 0px;
  background-color: ${({ theme, isPickedError }) => (isPickedError ? theme.colors.red[100] : theme.colors.white)};
  :hover {
    background-color: ${({ theme, isPickedError }) => (isPickedError ? theme.colors.red[100] : theme.colors.white)};
  }
  :focus {
    box-shadow: none;
  }
`;
